import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import {GetForingLang, GetInterfaceLang, GetOneLearningLanguage, getWord, DelWord, getDetailWord, GetAllLanguage, GetVocabularyStat, getWordFilter, PaginationWord} from '../../actions/index';
import PaginationComponent from '../pagination';

class Vocabulary extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
        this.state = {
            activePage: 1
        };
        this.addWord = this.addWord.bind(this);
        this.renderTooltip = this.renderTooltip.bind(this);
        this.renderWord = this.renderWord.bind(this);
        this.editWord = this.editWord.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.delWord = this.delWord.bind(this);
        this.delWordOpenModal = this.delWordOpenModal.bind(this);
        this.renderIcon = this.renderIcon.bind(this);
        this.filterInput = this.filterInput.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetForingLang(token);
        this.props.GetInterfaceLang(token);
        this.props.GetAllLanguage(token);
        this.props.getWord(token, this.props.params.id);
        this.props.GetVocabularyStat(this.props.params.id);
        this.props.GetOneLearningLanguage(this.props.params.id, token);
    }
    componentDidMount(){
        $('[data-toggle="tooltip"]').tooltip();
        $('.selectpicker').selectpicker();
    }
    componentWillUnmount(){
        this.props.lang.words = {}
    }
    handlePageChange(data){
        let token = localStorage.getItem('id_token_admin');
        this.setState({activePage: data});
        this.props.PaginationWord(token, this.props.params.id, data);
    };
    addWord(){
        this.context.router.push('/language/learning/edit/'+this.props.params.id+'/vocabulary/add');
    }
    editWord(id, item){
        this.context.router.push('/language/learning/edit/'+this.props.params.id+'/vocabulary/edit/'+id+'/');
    }
    delWord(){
        let token = localStorage.getItem('id_token_admin');
        this.props.DelWord(token, this.props.lang.words_detail.id).then((response)=>{
            if(response.payload.status == 204){
                this.closeModal();
                $('input[name="word"]').val('')
                this.props.getWord(token, this.props.params.id);
            }
        });
    }
    delWordOpenModal(id, flang, item){
        let token = localStorage.getItem('id_token_admin');
        let that= this;
        $('#DelWord').modal('show');
        $('#DelWord').on('shown.bs.modal', function () {
            that.props.getDetailWord(id, token, flang);
        });
    }
    closeModal(){
        $('#DelWord').modal('hide');
        this.props.lang.words_detail = {};
    }
    renderIcon(item){
        return item.map((code)=>{
            if(code.word_translations != '<p><br></p>' && code.word_translations != '') {
                return this.props.lang.interface_lang.results.map((lang) => {
                    if(lang.id == code.blang){
                        return <i>{lang.lang.code}</i>
                    }
                });
            }
        });
    }
    renderSelectFilter(id){
        this.props.lang.interface_lang.results.forEach((item)=>{
            if(item.lang.id == this.props.lang.learning_lang_one.lang.id){
                return false
            }else{
                if($('#'+id).find('option#'+item.id).length){
                    return false
                }else{
                    $('#'+id).append($('<option>', {
                        value: item.id,
                        text : item.lang.name,
                        id : item.id
                    }));
                }
            }
        })
        $('.selectpicker').selectpicker('refresh')
    }
    renderWord(){
        let count = this.state.activePage;
        let position;
        if(count > 1){
            position = (count-1)*100
        }else{
            position = 0
        }
        return this.props.lang.words.results.map((item, i)=>{
            return (
                <div className="white-block common-list two clearfix" key={item.id}>
                    <p>{position+i+1}</p>
                    <p className="common-item-with-tag">
                        <span onClick={this.editWord.bind(this, item.id)}>{item.word}</span>
                        {this.props.lang.interface_lang ? this.renderIcon(item.translations) : ""}
                    </p>
                    <p className="pull-right">
                        <button type="button" onClick={this.editWord.bind(this, item.id)}>
                            <span className="span glyphicon glyphicon-edit" aria-hidden="true"></span>
                        </button>
                        <button type="button" onClick={this.delWordOpenModal.bind(this, item.id, item.flang)}>
                            <span className="span glyphicon glyphicon-trash"></span>
                        </button>
                    </p>
                </div>
            )
        })
    }
    renderTooltip(){
        return this.props.lang.interface_lang.results.map((item)=>{
            if(item.lang.id == this.props.lang.learning_lang_one.lang.id){
                return false
            }else{
                return this.props.lang.vocabulary_stat.map((stat)=>{
                    if(item.id == stat.blang){
                        let string = stat.translated+ ' / ' +stat.total
                        return(
                            <p key={item.id} className="pull-left info-item" data-toggle="tooltip" data-placement="top" title={string} >{item.lang.name}</p>
                        )
                    }
                })
            }
        })
    }
    filterInput(e){
        if(e.target.name == 'woblang'){
            $('select[name="wblang"]').val('selectDefault')
        }
        if(e.target.name == 'wblang'){
            $('select[name="woblang"]').val('selectDefault')
        }
        let token = localStorage.getItem('id_token_admin');
        let data = {
            flang: $('input[name="flangs"]').val(),
            word: $('input[name="word"]').val(),
            woblang: $('select[name="woblang"]').val() != 'selectDefault' ? $('select[name="woblang"]').val() : '',
            wblang: $('select[name="wblang"]').val() != 'selectDefault' ? $('select[name="wblang"]').val() : ''
        }

        this.props.getWordFilter(token, data);
        $('.selectpicker').selectpicker('refresh')
        // $('#searchSentence').submit()
    }
    render() {
        return (
            <div>
                <div className="dashboard-wrapper">
                    <div className="dashboard-title clearfix">
                        <div className="pull-left">
                            <p className="dashboard-title">Vocablulary</p>
                            <p className="dashboard-text">{this.props.lang.learning_lang_one.lang ? this.props.lang.learning_lang_one.lang.name : "" }</p>
                        </div>
                        <button onClick={this.addWord} type="button" className="pull-right btn btn-primary">
                            <span className="glyphicon glyphicon-plus" aria-hidden="true"></span>
                            Add word
                        </button>
                    </div>
                    <div>
                        <div className="col-md-12">
                            <div className="white-block ">
                                <div className="clearfix static-header-buttons">
                                    <p className="pull-left">Translate to</p>
                                    <div className="block-info-group">
                                        {this.props.lang.interface_lang.results && this.props.lang.foring_lang.results && this.props.lang.learning_lang_one.lang ? this.renderTooltip() : ""}
                                    </div>
                                </div>
                                <div className="separate-horizontal"> </div>
                                <div className="clearfix">
                                    <input type="text" name="flangs" value={this.props.params.id} hidden="hidden" onChange={this.filterInput}/>
                                    <div className="col-md-6">
                                        <div className=" input-group search_block">
                                            <span className="input-group-addon glyphicon glyphicon-search"></span>
                                            <input type="search" name="word" className="form-control" placeholder="Search" onChange={this.filterInput}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input-half pull-left mr20">
                                            <select className="selectpicker" name="woblang" id="Without" defaultValue="selectDefault" data-live-search="true" onChange={this.filterInput}>
                                                <option value="selectDefault">Without translation into</option>
                                                {this.props.lang.foring_lang.results && this.props.lang.learning_lang_one.lang && this.props.lang.interface_lang.results ? this.renderSelectFilter('Without') : ""}
                                            </select>
                                        </div>
                                        <div className="input-half pull-left">
                                            <select className="selectpicker" name="wblang" id="into" defaultValue="selectDefault" data-live-search="true" onChange={this.filterInput}>
                                                <option value="selectDefault">Translated into</option>
                                                {this.props.lang.foring_lang.results && this.props.lang.learning_lang_one.lang && this.props.lang.interface_lang.results ? this.renderSelectFilter('into') : ""}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.props.lang.words.results && this.props.lang.words.results.length > 0 ?
                            <div>
                                <div className="col-md-12">
                                    <div className="common-list two clearfix">
                                        <p>#</p>
                                        <p>Name</p>
                                        <p className="pull-right">Option</p>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    { this.renderWord() }
                                </div>
                                {this.props.lang.words.results ?
                                    <PaginationComponent
                                        data={this.props.lang.words}
                                        activePage={this.state.activePage}
                                        handlePageChange = {this.handlePageChange}
                                    />
                                    :
                                    ""}
                            </div>
                            :
                            <div className={this.props.lang.words.results && this.props.lang.words.results.length < 0 || $.isEmptyObject(this.props.lang.words) ? "for_preloader" : 'for_preloader dn'}>
                                <div className="preloader-wrapper big active">
                                    <div className="spinner-layer spinner-blue-only">
                                        <div className="circle-clipper left">
                                            <div className="circle" />
                                        </div>
                                        <div className="gap-patch">
                                            <div className="circle" />
                                        </div>
                                        <div className="circle-clipper right">
                                            <div className="circle" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {this.props.lang.words.results && this.props.lang.words.results.length === 0 && <p className="noResults">No items result</p>}
                    </div>

                    <div className="modal fade" id="DelWord" tabIndex="-1" role="dialog" aria-labelledby="DelWordLabel">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" onClick={this.closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div>
                                <div className="modal-body text-center">
                                    <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#DelWord"></span>
                                    <p>Do you really want to delete word {this.props.lang.words_detail ? <span>{this.props.lang.words_detail.word}</span> : ""}?</p>
                                </div>
                                <div className="modal-footer text-center">
                                    <button onClick={this.closeModal} type="button" className="btn btn-default">No</button>
                                    <button onClick={this.delWord} type="button" className="btn btn-primary">Yes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

function  mapStateToProps(state) {
    return{
        lang: state.lang
    }
}
export default connect(mapStateToProps, {GetForingLang, GetInterfaceLang, GetOneLearningLanguage, getWord, DelWord, getDetailWord, GetAllLanguage, GetVocabularyStat, getWordFilter, PaginationWord})(Vocabulary);


// WEBPACK FOOTER //
// ./src/components/language/vocabulary.js